import { render, staticRenderFns } from "./ConveniosInfoPage.vue?vue&type=template&id=0f2004c7&scoped=true"
import script from "./ConveniosInfoPage.js?vue&type=script&lang=js&external"
export * from "./ConveniosInfoPage.js?vue&type=script&lang=js&external"
import style0 from "./ConveniosInfoPage.vue?vue&type=style&index=0&id=0f2004c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2004c7",
  null
  
)

export default component.exports